<template>
  <div>
    <Header />
    <main role="main">
      <slot></slot>
    </main>
  </div>
</template>

<script>
import Header from '../components/Header';

export default {
  name: 'DefaultLayout',
  components: {
    Header,
  }
}
</script>

<style>

</style>
